module.exports = __webpack_public_path__ + "icons_2dba6.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/icons.eot
// module id = 51
// module chunks = 0